export const getWordCount = (value: string | undefined) =>
	value?.trim().split(/\s+/).filter(Boolean).length ?? 0;
